import { InputBase } from "components/Atoms/formInputs/InputBase";
import { useValidate } from "formvalidation/hooks";
import React, { useRef } from "react";
import { saveOrCancel } from "utilities/inputUtils";

interface Props {
  focusOnMount?: boolean
  value: string
  onChanged: (newTransitNumber: string) => void
  onEnter?: () => void
  onEsc?: () => void

  validatorKey: string
}

const TransitNumberInput = (props: Props) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const isValidInput = (input: string) => {
    if (input.trim().length === 0) return true;

    return /^\d+$/.test(input) &&
      input.length === serverReference.constants.bankAccount.exactTransitNumberLength;
  };
  const validate = async (input: string) => {
    const isValid = isValidInput(input);
    return isValid;
  };

  const formatInput = (input: string, e?) => {
    const sanitizedInput = input
      .trim()
      .replace(/\D/g, "")
      .substring(0, serverReference.constants.bankAccount.exactTransitNumberLength);

    if (isValidInput(sanitizedInput)) {
      e?.preventDefault();
      props.onChanged(sanitizedInput);
      return sanitizedInput;
    }

    return false;
  };

  const onPaste = (e) => {
    const text: string = e.clipboardData.getData("text").trim();
    formatInput(text, e);
  };

  const onBlur = () => {
    const formatted = formatInput(props.value);
    validate(formatted || props.value);
  };

  const validation = useValidate({
    key: props.validatorKey,
    title: "Transit number",
    ref: inputRef,
    value: props.value,
    validate
  });

  return <InputBase
    ref={inputRef}
    value={props.value}
    maxLength={serverReference.constants.bankAccount.exactTransitNumberLength}
    error={validation.error.hasError}
    onBlur={onBlur}
    onPaste={onPaste}
    onChange={props.onChanged}
    onKeyDown={e => saveOrCancel(e, { onEnter: props.onEnter, onEsc: props.onEsc, validation, value: props.value })}
    focusOnMount={props.focusOnMount}
    placeholder="00000"
  />;
};

export default TransitNumberInput;